import React, { useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import * as types from "_constants";
import Header from "_components/AppBar";
import Footer from "_components/Footer";
// import { getLoggedInStatus } from "_redux/actions/authActions";

import { spacing } from "@material-ui/system";
import {
  Hidden,
  CssBaseline,
  Paper as MuiPaper,
  withWidth,
  Link,
  Container,
} from "@material-ui/core";

import { isWidthUp } from "@material-ui/core/withWidth";
import { signIn } from "_redux/actions/appActions";
import { signOut } from "_redux/actions/appActions";
import { parseJwt, checkJwtExpired } from "_utils/helpers";

const drawerWidth = 258;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};
  padding: 24px;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;


const Dashboard = ({ children, routes, width }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const history = useHistory();
  const params = useParams();

  const auth = useSelector((state) => state.authReducer);
  const { organizationWebsite } = useSelector(state => state.appReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    // first key is the org slug
    if (Object.keys(params).length === 0) {
      // redirect to 500 if no url is found
      history.push(`/error`);
      return;
    }

    if (!auth.user && Object.keys(params).length > 0) {
      // check if localstorage has data
      const signInOrRedirect = async () => {
        const userToken = localStorage.getItem('access_token');
        if (userToken) {
          const user = parseJwt(userToken);
          if (!checkJwtExpired(user.exp)) {
            await dispatch(signOut());
            history.push(`/auth/${params.organizationSlug}/verify?redirect_url=/overview/${params.organizationSlug}`);
          } else {
            await dispatch({
              type: types.AUTH_SIGN_IN_SUCCESS,
              payload: {
                user
              }
            });
            setIsLoaded(true);
          }
        } else {
          history.push(`/auth/${params.organizationSlug}/verify?redirect_url=/overview/${params.organizationSlug}`);
        }
      };
      signInOrRedirect();
    } else {
      setIsLoaded(true);
    }
  }, [auth, dispatch, params]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (!isLoaded) {
    return <Root></Root>;
  } else {
    return (
      <Root>
        <CssBaseline />
        <GlobalStyle />
        <AppContent>
          <Header onDrawerToggle={handleDrawerToggle} />
          <MainContent p={isWidthUp("lg", width) ? 12 : 5}>
            <Container maxWidth="lg">
              {children}
            </Container>
          </MainContent>
          {organizationWebsite && <Footer
            background={organizationWebsite.home?.colors.footer_background}
            color={organizationWebsite.home?.colors.footer_color} />
          }
        </AppContent>
      </Root>
    );
  }
};

export default withWidth()(Dashboard);
